// extracted by mini-css-extract-plugin
export default {"carousel":"LocationSection_carousel__WzPUZ","location":"LocationSection_location__Mhp8R"};